import React, { useEffect, useState } from 'react';
import ChartSkeleton from '../../ui/chart-skeleton/chart-skeleton';
import WidgetWrapper from '../widget-wrapper/widget-wrapper';
import { useSamarthDashboardContext } from 'utils/samarth-dashboard-context/hooks/useSamarthDashboardContext';
import styles from './mai-widget.module.css';
import { useKpiData } from 'utils/samarth-dashboard-context/hooks/useKpiData';
import SingleLineCharts from '../../ui/SinglelineCharts/singlelineCharts';
import SingleTabTable from '../../ui/SingleTabTable';

export default function MAIWidget() {
  const {  state } = useSamarthDashboardContext();
  const globalViewMode = state.viewMode.globalViewMode;
  const { filters } = useKpiData();
  const { actionFilters: actionFilter,currentWeek : currWeek } = filters;
  const loader = state.dashboardData.isLoading.mai;
  const chartData = state.dashboardData.mai;
  const [visibleData, setVisibleData] = useState([...chartData].slice(0, 4));

  const [isOn, setIsOn] = useState(false);
  const handleToggle = () => {
    setIsOn(!isOn);
  };

  const getColorClass = (value) => {
    if (value > 80) return styles.textGreen;
    if (value > 60) return styles.textYellow;
    return styles.textRed;
  };

  useEffect(() => {
    if (actionFilter) {
      const weekData =
        chartData[0]?.[globalViewMode === 'graph' ? currWeek : state.dashboardData.weekCurrent] || [];
      if (!isOn) {
        setVisibleData(weekData.slice(0, 4));
      } else {
        setVisibleData(weekData);
      }
    } else if (!isOn) {
      setVisibleData([...chartData].slice(0, 4));
    } else {
      setVisibleData(chartData);
    }
  }, [chartData, isOn, currWeek, globalViewMode, actionFilter, state.dashboardData.weekCurrent]);

  return (
    <WidgetWrapper
      title="MAI"
      isTableView={globalViewMode === 'table'}
      isDialogOpen={isOn}
      setIsDialogOpen={handleToggle}
      infoText='MAI indicates how well the available supply of a material meets its demand'
    >
      {loader ? (
        <ChartSkeleton isOn={isOn} />
      ) : (
        <>
          {globalViewMode === 'graph' ? (
            <SingleLineCharts data={visibleData} isExpansionNeeded />
          ) : (
            <SingleTabTable
              data={visibleData}
              keys={['week', 'value']}
              colorLogic={getColorClass}
            />
          )}
        </>
      )}
    </WidgetWrapper>
  );
}